import { Box } from '@mui/material';

function CallToAction () {
    return (
        
        <Box sx={{
            backgroundColor: '#008DDA',
            textAlign: 'center',
            padding: '1px',
            margin: 'auto',
            textTransform: 'uppercase',
            color: 'white',
        }}>
            <p>Visit us today! Located in Charlotte, NC & Salisbury, NC</p>
        </Box>
        
    )
};

export default CallToAction;